import React, { useState } from "react";
import axios from "axios";
import { Button } from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";

function BajaMultiple(props) {
  const [text, setText] = useState(false);
  const URL_BAJA = `${props.URL_BAJA}/${props.idStatus}`;
  const URL_BAJA_HIJO = `${props.hijo}/${props.idStatus}`;

  function baja() {
    Swal.fire({
      title: "Estas seguro?",
      text: "Se dara de baja!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, dar de Baja!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            URL_BAJA,
            {
              is_active: "No",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
            .patch(
              URL_BAJA_HIJO,
              {
                is_active: "No",
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            ).then(()=>{
              Swal.fire({
                position: "center",
                icon: "success",
                title: "Se dio de Baja",
                showConfirmButton: false,
                timer: 2000,
              });
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
            });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      }
    });
  }


  function alta() {
    Swal.fire({
      title: "Estas seguro?",
      text: "Se dara de Alta!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, dar de Alta!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            URL_BAJA,
            {
              is_active: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Se dio de Alta",
              showConfirmButton: false,
              timer: 2000,
            });
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      }
    });
  }

  return (
    <>
      {props.is_active == "Si" ? (
        <span>
          <Button title="Desactivar"
            color="primary"
            id="Baja"
            onClick={baja}
            size="sm"
          >
          <i class="far fa-check-circle"></i>
          </Button>
        </span>
      ) : (
        <span>
          <Button title="Activar" color="danger" onClick={alta} size="sm">
            <i class="far fa-times-circle"></i>
          </Button>
        </span>
      )}
    </>
  );
}

export default BajaMultiple;

